module.exports = __webpack_public_path__ + "static/media/surprise.6bb354e4.svg";